import React from 'react'
import ExpenseCategoryLabels from 'src/app/ExpenseCategoryLabels/ExpenseCategoryLabels'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import ExpenseCategoriesAccountingAppRoute from 'src/navigation/appRoutes/organization/expenseCategoriesAccounting.appRoute'
import ExpenseCategoriesAdditionalFieldsAppRoute from 'src/navigation/appRoutes/organization/expenseCategoriesAdditionalFields.appRoute'
import { expenseCategoryLabelsRouteProps } from 'src/navigation/routeProps'

const ExpenseCategoryLabelsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseCategoryLabels,
  routeProps: expenseCategoryLabelsRouteProps,
  component: <ExpenseCategoryLabels />,
  subRoutes: [],
  exceptions: [
    ExpenseCategoriesAccountingAppRoute,
    ExpenseCategoriesAdditionalFieldsAppRoute,
  ],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseCategoryLabelsAppRoute
